module.exports = __webpack_public_path__ + "static/babel-original-529bf9cdff934f9ce5f709e3c2e9073d.svg";